import { render } from "./RanksCollection.vue?vue&type=template&id=9eb9b5b8&scoped=true"
import script from "./RanksCollection.vue?vue&type=script&lang=js"
export * from "./RanksCollection.vue?vue&type=script&lang=js"

import "./RanksCollection.vue?vue&type=style&index=0&id=9eb9b5b8&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb9b5b8"]])

export default __exports__